import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.4_@babel+core@7.27.4_@playwright+test@1.50.1_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/favicon/favicon-512.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/apiary.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/auto-parts.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/baker.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/baristas.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/cheese-maker.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/compost.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/firewood.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/fruit-seller.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/furniture-manufacturer.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/simple-order-wholesale-order-management-software-website.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/three-bakers.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/DemoBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/footer/FooterLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/menubar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/splashes/ContentSplash.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/splashes/SiteSplash.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.tailwind.css");
